<ui-sidebar-page>
  <ui-header brand="Werfy Admin Portal"><ui-user-menu [items]="menuItems"></ui-user-menu></ui-header>
  <ui-sidebar [navigationItems]="navigationItems"></ui-sidebar>
  <router-outlet></router-outlet>
</ui-sidebar-page>
